import { render, staticRenderFns } from "./MentalDrawing.vue?vue&type=template&id=69498389&lang=pug&"
import script from "./MentalDrawing.vue?vue&type=script&lang=js&"
export * from "./MentalDrawing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports